import { render, staticRenderFns } from "./mdiAlertOctagonOutline.vue?vue&type=template&id=04aa5acb"
import script from "./mdiAlertOctagonOutline.vue?vue&type=script&lang=js"
export * from "./mdiAlertOctagonOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
